import React, {Component, Fragment} from "react";
import {
    Table
} from "reactstrap";
import Paging from '../paging'
import 'moment/locale/id'
import {pageNumber} from "../../functions/functionGeneral";
import "react-image-lightbox/style.css";
import {clear_auth, set_auth} from "../../reducers/Auth";
import {connect} from "react-redux";
import Breadcrumb from "../common/breadcrumb";

export class Request_migrasi_list extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataRequestMigrasi      : [],
            perPage                 : 0,
            paging                  : 25,
            token                   : "",
            pageCount               : 0,
            currentPage             : 0,
            isLoading               : true
        }
        this.handlePaging               = this.handlePaging.bind(this);
        this.handlePageClick            = this.handlePageClick.bind(this);
    }

    handlePaging(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            isLoading: true,
            [name]: value
        },()=>{
            this.loadData()
        })
    }

    handlePageClick(data) {

        let selected = data.selected; // zero based index

        this.setState({ currentPage: selected }, () => {
            this.loadData();

        });
    };

    loadData() {
        let formData = {
            page    : this.state.currentPage + 1,
            paging  : this.state.paging,
        };

        this.props.request('admin/perusahaan/list-request', formData, 'POST')
            .then((response) => {
                if (response.success) {
                    var result = response.data;

                    this.setState({
                            dataRequestMigrasi  : result.data,
                            pageCount           : result.last_page,
                            perPage             : result.per_page,
                        })
                }
                this.setState({ isLoading: false })
            })

    }

    componentDidMount() {
        this.loadData()
    }

    render() {
        var no = 0;

        if(['Admin'].indexOf(this.props.user.level) >= 0) {
            return (
                <Fragment>
                    <Breadcrumb title="Daftar Request Migrasi" parent="Perusahaan" />
                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-header">
                                <h5 style={{ color: '#143B5E', fontSize: '18px'}}>Daftar Request Migrasi</h5>
                            </div>
                            <div className="request-migrasi">
                                <div className="clearfix"></div>
                                <Table className="mb-5">
                                    <thead>
                                    <tr>
                                        <th width={30}>#</th>
                                        <th width={380}>Perusahaan Nama</th>
                                        <th width={400}>Perusahaan Email</th>
                                        <th>Tanggal Request</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {!this.state.isLoading && this.state.dataRequestMigrasi.length === 0 ? <td colSpan={9}>Data Kosong...</td> :this.state.dataRequestMigrasi.map((item, index) => {
                                        no += 1
                                        return (
                                            <tr key={index}>
                                                <small>
                                                    <th scope="row">{pageNumber(no, this.state.perPage, this.state.currentPage)}</th>
                                                </small>
                                                <td className="td-request-migrasi">
                                                    {item.perusahaan.perusahaan_nama ? item.perusahaan.perusahaan_nama : '-'}
                                                </td>
                                                <td className="td-request-migrasi">
                                                    {item.perusahaan.perusahaan_email ? item.perusahaan.perusahaan_email : '-'}
                                                </td>
                                                <td className="td-request-migrasi">
                                                    {item.request_date ? item.request_date : '-'}
                                                </td>
                                            </tr>
                                        )})}
                                    </tbody>
                                </Table>
                                <Paging
                                    className="float-right"
                                    handlePageClick={this.handlePageClick}
                                    pageCount={this.state.pageCount}
                                    currentPage={this.state.currentPage}
                                />
                            </div>

                        </div>
                    </div>
                </Fragment>
            );
        } else {
            return (
                <Fragment>
                    <h5 className="text-center pt-4">Anda tidak punya akses ke halaman ini.</h5>
                </Fragment>
            )
        }
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(Request_migrasi_list);
